<template>
    <transition name="modal">
		<div class="modal-mask" @click="$emit('close')">
			<div class="modal-wrapper" @click.stop role="document" style="overflow-y:auto;position:absolute">
				<div class="modal-container modal-dialog">
					<div class="modal-content">
						<div class="modal-header">
							<div class="row">
                                <div class="col-xs-6">
                                    Preview
                                </div>
                                <div class="col-xs-6">
                                <button type="button" class="close" @click="$emit('close')" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>

                                </div>

							</div>
							
						</div>

                        <div class="modal-body">
                            <slot name="body"></slot>
                        </div>

                        
					</div>
				</div>
			</div>
		</div>
    </transition>
</template>

<script>
    export default {
        mounted: function () {
            let vm = this
            document.addEventListener("keydown", (e) => {
                if (e.keyCode == 27) {
                    vm.$emit('close')
                }
            });
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/elements/PreviewImage.vue